<div bsModal #modalRef="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <span>Do you want to keep all group information?</span>
        <img class="cancel" src="assets/img/x.svg" (click)="resolveAndClose(UnlinkAllOption.CANCEL)" alt="" />
      </div>
      <div class="modal-footer">
        <div style="margin-right: 0">
          <button class="btn btn-cancel" (click)="resolveAndClose(UnlinkAllOption.CANCEL)">Cancel</button>
        </div>
        <div style="margin-right: 0">
          <button class="btn btn-cancel" (click)="resolveAndClose(UnlinkAllOption.CLEAR)">
            Unlink all and clear group info
          </button>
        </div>
        <div style="margin-left: 0">
          <button class="btn btn-confirm" (click)="resolveAndClose(UnlinkAllOption.KEEP)">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>
